const preSpaceRouter = [
  {
    path: "preStockPlan",
    name: "preStockPlan",
    component: () => import("../pages/prestorage/preStockPlan.vue"),
    meta: {
      title: "前置仓代采计划",
    },
  },
  {
    path: "invitationPool",
    name: "InvitationPool",
    component: () => import("../pages/prestorage/InvitationPool.vue"),
    meta: {
      title: "一手邀约池",
    },
  },
  {
    path: "invitationPoolEdit",
    name: "InvitationPoolEdit",
    component: () => import("../pages/prestorage/InvitationPoolEdit.vue"),
    meta: {
      title: "创建邀约",
    },
  },
  {
    path: "invitationPoolDetail",
    name: "InvitationPoolDetail",
    component: () => import("../pages/prestorage/InvitationPoolDetail.vue"),
    meta: {
      title: "邀约详情",
    },
  },
  {
    path: "preStockPlanEdit/:psp_id",
    name: "preStockPlanEdit",
    component: () => import("../pages/prestorage/preStockPlanEdit.vue"),
    meta: {
      title: "创建前置仓代采计划",
    },
  },
  {
    path: "stock/pre-stock-report",
    name: "pre-stock-report",
    component: () => import("../pages/preStockReport/preStockReport.vue"),
    meta: {
      title: "前置仓报表",
    },
  },
  {
    // 前置仓计划商品
    path: "stock/pre-stock-goods",
    name: "PreStockGoods",
    component: () => import("../pages/PreStockGoods/PreStockGoods.vue"),
    meta: {
      title: "前置仓计划商品",
    },
  },
];
export default preSpaceRouter;



// WEBPACK FOOTER //
// ./src/router/preStorageRouter.js